import React from "react";

const WhoWeAre = () => {
    return (
        <div className="about-area rn-section-gap who-we-are">
            <div className="container">

                {/* TITLE CENTER */}
                <div className="row">
                    <div className="col-lg-12 text-center mb--30">
                        <h3 className="title">WHO WE ARE</h3>
                    </div>
                </div>

                {/* CONTENT + ONE IMAGE */}
                <div className="row row--40 align-items-center">

                    {/* LEFT CONTENT */}
                    <div className="col-lg-6 col-md-12">
                        <p className="description" style={{ marginBottom: "20px" }}>
                            <strong>KR POWER SUPPORT PVT LTD</strong> Electrical Contractors & Cable Tray and Panel Builders,
                            established in the year <strong>1995</strong> with an ambition to deliver the needs of
                            customers requiring services in the electrical field. For over 3 decades, we provide 
                            quality services and satisfaction in all our works. We carry out electrical installation 
                            and panel works for large-scale industries.
                        </p>

                        <p className="description" style={{ marginBottom: "20px" }}>
                            <strong>KR Engineering</strong>, our sister concern, is widely involved in manufacturing 
                            Panel Boards, Control Panels, Bus Ducts, Cable Trays, and Solar Structures. From our base,
                            we extended our quality services to major cities across India.
                        </p>

                        <a href="/about-us" className="btn-default mt--20">READ MORE</a>
                    </div>

                    {/* RIGHT SIDE ONE IMAGE */}
                    <div className="col-lg-6 col-md-12 mt_sm--30">
                        <img 
                            src="./images/about/about7.webp"      // Single human image
                            alt="Global heavy fabrication industries"
                            style={{ width: "100%", borderRadius: "12px" }}
                        />
                    </div>

                </div>

                {/* ORDERS EXECUTED
                <div className="row mt--50">
                    <div className="col-lg-12 text-center">
                        <h3 className="title mb--20">Orders Executed</h3>
                    </div>

                    <div className="col-lg-12">
                        <ul
                            style={{
                                display: "grid",
                                gridTemplateColumns: "1fr 1fr 1fr",
                                gap: "15px 20px",
                                listStyle: "none",
                                maxWidth: "900px",
                                margin: "0 auto",
                                paddingLeft: 0
                            }}
                        >
                            {executedOrders.map((item, index) => (
                                <li 
                                    key={index} 
                                    style={{
                                        display: "flex",
                                        alignItems: "center"
                                    }}
                                >
                                    <FiCheck style={{ marginRight: "8px" }} />
                                    <span>{item}</span>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div> */}

            </div>
        </div>
    );
};

export default WhoWeAre;
